<!--打印样式要写在 print/leaveTemp.html 的style内部-->
<template>
  <div class="leave-temp w-100">
    <div class="grid leave-temp__top" >
      <div class="grid-item">
        <print-signature-area
          :leave-data="leaveData"
          :status="'teacherStatus'"
          :opinion="'teacherOpinion'"
          :user-name="'teacherUserName'"
          :sign-time="'teacherTime'"
        >
          <template v-slot:title>
            <div>辅导员意见：</div>
<!--            <div>（与家长联系情况；是否同意其子女出校园；是否有相关证明材料）</div>-->
          </template>
        </print-signature-area>
      </div>
      <div class="grid-item">
        <print-signature-area
          title="学院学生办公室核批意见"
          :leave-data="leaveData"
          status="subCollegeStatus"
          opinion="subCollegeOpinion"
          user-name="subCollegeUserName"
          sign-time="subCollegeTime"
        />
      </div>
    </div>
    <div class="grid leave-temp__center">
      <div class="grid-item" v-for="item in filterTypeMapList.slice(2,5)" :key="item.filterType">
        <print-signature-area
          :title="item.formLabel"
          :leave-data="leaveData"
          :status="item.statusKey"
          :opinion="item.editKey+'Opinion'"
          :user-name="item.editKey+'UserName'"
          :sign-time="item.editKey+'Time'"
        />
      </div>
    </div>
    <div class="grid leave-temp__bottom">
      <div class="grid-item">
        销假时间：
        <span v-if="leaveData.verifyTime"
              style="font-size: 15px;">{{ leaveData.verifyTime|formatDate(' YYYY 年 MM 月 DD 日  HH 时 mm 分') }}</span>
      </div>

      <div class="grid-item font-right">
        辅导员
      </div>
      <div class="grid-item">
        {{ leaveData.verifyFlag ? leaveData.teacherUserName : '' }}

      </div>
    </div>
  </div>
</template>

<script>
import PrintSignatureArea from '@/views/pages/secondCollege/leave-out/component/printSignatureArea.vue'

export default {
  components: { PrintSignatureArea },
  props: {
    filterTypeMapList: {
      type: Array,
      default: () => ([])
    },
    leaveData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
<style lang="scss">
.leave-temp{
  .grid{
    &+.grid{
      border-top:  1px solid #606266;
    }
    &.leave-temp__top{
      grid-template-columns: 2fr 1fr;
    }
    &.leave-temp__center{
      grid-template-columns: repeat(3,1fr);
    }
    &.leave-temp__bottom{
      grid-template-columns:4fr 1fr 1fr;
    }
    .grid-item{
      padding: 0 12px;
      box-sizing: border-box;
    }
  }
}
</style>
